<template>
<v-app>
    <template>
      
        <dashboard-core-app-bar v-if="!$route.meta.public" v-model="expandOnHover" :key="this.store_instancia + 'bar'"/>
        <dashboard-core-drawer v-if="!$route.meta.public" :expand-on-hover.sync="expandOnHover" :key="this.store_instancia + pagos + 'menu'"/>
    <p/>
        <v-main>
            <router-view />
        </v-main>
       
        <dialog-loader ref="dialogLoader"></dialog-loader>
     
         </template>

</v-app>
</template>

<script>
import Vue from "vue";
import {
    mapState
} from "vuex";
import DialogLoader from "@/components/DialogLoader";

import axios from "axios";



const vm = new Vue();

export default {
    components: {
        DialogLoader,
        DashboardCoreAppBar: () => import("@/components/layout/AppBar"),
        DashboardCoreDrawer: () => import("@/components/layout/Drawer"),
       
    },
    name: "App",
    data: () => ({
        tipos_user: [],
        fab: false,
        marquee: "",
        search: "",
        expandOnHover: true,
        mostrarmenu: false,
        colortema: false,
        expanded: true,
        rightDrawer: false,
        snackbar: {
            show: false,
            text: "",
            color: ""
        },
       

        direction: "top",
        fab: false,
        fling: false,
        hover: false,
        tabs: null,
        top: false,
        right: true,
        bottom: true,
        left: false,
        transition: "slide-y-reverse-transition",

    }),
    computed: mapState({
        store_instancia() {

            return this.$store.state.instancia + this.$store.state.datetime;
        },
        filteredItems() {
            return this.users.filter(item => {
                
                return item.nombre.toLowerCase().indexOf(this.search.toLowerCase()) > -1 
            })
        },
        idusuario(){
            if(this.$local_storage.get(this.$crypto.SHA256("id_usuario")))
                return parseInt(this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("id_usuario"))));
            else
                return 0;
        },
        pagos(){
            return this.$store.state.pagos;
        }
    }),

    mounted() {
        this.$root.$dialogLoader = this.$refs.dialogLoader;
       
    },
    created() {
        window.getApp = this;
        
       
    },
    methods: {
        
    }
};
</script>
<style scoped>
    .sc-header {
    min-height: 50px;
    border-top-left-radius: 9px;
    border-top-right-radius: 9px;
    padding: 5px;
    box-shadow: 0 1px 4px rgba(0,0,0,.2);
    position: relative;
    box-sizing: border-box;
    display: flex;
    }
    .sc-header--title {
  align-self: center;
  padding: 5px;
  flex: 1;
  user-select: none;
  font-size: 12px;
}

.sc-header--title.enabled {
  cursor: pointer;
  border-radius: 5px;
}
</style>